/* Thème neutre v3 — suivi de commande intégré au site (4.2).
   Données : commandes du client connecté (écrites par Liquid), ou lien de l'e-mail d'expédition
   ?n=<numéro de suivi>&c=<numéro de commande>&d=<date de commande AAAA-MM-JJ>&e=<date d'expédition AAAA-MM-JJ>.
   Tout s'affiche dans la page : aucun cadre, aucun lien vers un autre site, aucune mention de provenance.
   La position sur le trajet est une estimation calculée sur les dates réelles de la commande, et elle le dit. */
(function () {
  'use strict';
  var MONTHS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  var DAYS = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
  function pd(s) { var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s || ''); return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null; }
  function fd(d, withDay) { return (withDay ? DAYS[d.getDay()] + ' ' : '') + (d.getDate() === 1 ? '1er' : d.getDate()) + ' ' + MONTHS[d.getMonth()]; }
  function add(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function days(a, b) { return Math.round((b - a) / 864e5); }
  function today() { var n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate()); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function clean(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function digits(s) { return String(s || '').replace(/\D/g, ''); }
  function isOrderNo(s) { return /^[A-Z]{0,4}\d{3,9}$/.test(s); }
  function isTrack(s) { return /^[A-Z0-9]{9,34}$/.test(s) && /\d{6,}/.test(s) && !isOrderNo(s); }
  function plural(n, w) { return n + ' ' + w + (n > 1 ? 's' : ''); }

  /* modèle d'une commande : {name, date, ships:[{d,n}], cancelled} */
  function modelFromOrder(o) {
    var seen = {}, ships = [];
    (o.ships || []).forEach(function (s) { var k = (s.n || '') + '|' + (s.d || ''); if (!seen[k]) { seen[k] = 1; ships.push({ d: s.d, n: s.n ? clean(s.n) : '' }); } });
    return { name: o.name, date: o.date, ships: ships, cancelled: !!o.cancelled };
  }

  /* état d'un colis : étape (0 reçue, 1 expédiée, 2 en route, 3 transporteur local, 4 livrée) et avancée f de 0 à 1 */
  function compute(m, idx, MIN, MAX, now) {
    now = now || today();
    var d = pd(m.date), ship = m.ships[idx] || null, e = ship ? pd(ship.d) : null, r = { step: 0, f: 0, idle: false };
    var known = MIN > 0 && MAX >= MIN;
    if (m.cancelled) { r.title = 'Commande annulée'; r.sub = 'Cette commande a été annulée. Une question ? Écrivez-nous.'; r.idle = true; r.off = true; return r; }
    if (!d && !e) { r.idle = true; r.title = 'Colis en route'; r.sub = 'Votre colis est expédié.'; return r; }
    if (d && known) { r.from = add(d, MIN); r.to = add(d, MAX); }
    if (!e) {
      r.step = 1; r.f = 0.125; r.title = 'En préparation';
      r.sub = 'Votre commande est enregistrée. Vous recevrez un e-mail avec le numéro de suivi dès l’expédition.';
      return r;
    }
    r.since = Math.max(0, days(e, now));
    if (!known) { r.step = 2; r.f = 0.5; r.title = 'En route vers vous'; r.sub = r.since === 0 ? 'Votre colis vient de partir.' : 'Votre colis voyage depuis ' + plural(r.since, 'jour') + '.'; return r; }
    var end = r.to || add(e, MAX), span = Math.max(1, days(e, end)), t = Math.min(1, Math.max(0, days(e, now) / span));
    r.f = 0.25 + t * 0.7;
    r.step = r.f >= 0.75 ? 3 : 2;
    r.late = days(end, now) > 3;
    if (r.late) { r.title = 'Délai habituel dépassé'; r.sub = 'Si vous n’avez pas reçu votre colis, écrivez-nous : nous lançons une recherche tout de suite.'; }
    else if (r.step === 3) { r.title = 'Dernière ligne droite'; r.sub = 'Votre colis devrait être chez le transporteur local ou tout près.'; }
    else { r.title = 'En route vers vous'; r.sub = r.since === 0 ? 'Votre colis vient de partir.' : 'Votre colis voyage depuis ' + plural(r.since, 'jour') + '.'; }
    return r;
  }

  if (typeof window !== 'undefined') window.NTSuivi = { _t: { pd: pd, clean: clean, isOrderNo: isOrderNo, isTrack: isTrack, modelFromOrder: modelFromOrder, compute: compute } };
  if (typeof document === 'undefined' || !document.addEventListener) return;

  function init() {
    var root = document.getElementById('nt-suivi');
    if (!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    var cfg = {}, orders = [];
    try { cfg = JSON.parse(document.getElementById('nt-suivi-config').textContent) || {}; } catch (e) {}
    try { var oe = document.getElementById('nt-suivi-orders'); if (oe) orders = JSON.parse(oe.textContent) || []; } catch (e) {}
    var MIN = cfg.delivMin > 0 ? cfg.delivMin : 0, MAX = cfg.delivMax > 0 ? cfg.delivMax : 0;
    var CONTACT = cfg.contact || '';
    var tplEl = document.getElementById('nt-suivi-runner-tpl');
    var RUNNER = tplEl ? (tplEl.innerHTML || '').trim() : '';
    // sans dessin de coureur dans la fiche de marque : un simple repère rond
    var HASRUN = /^<svg[\s>]/i.test(RUNNER);
    if (!HASRUN) RUNNER = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10"/></svg>';

    var form = document.getElementById('nt-suivi-form'), input = document.getElementById('nt-suivi-input'),
        hint = document.getElementById('nt-suivi-hint'), result = document.getElementById('nt-suivi-result'),
        box = document.getElementById('nt-suivi-orders-box'), list = document.getElementById('nt-suivi-orders-list');
    if (!result) return;
    function say(t) { if (hint) hint.textContent = t || ''; }

    function render(m, idx) {
      idx = idx || 0;
      var r = compute(m, idx, MIN, MAX), ship = m.ships[idx] || null, d = pd(m.date), e = ship ? pd(ship.d) : null;
      var labels = ['Reçue', 'Expédiée', 'En route', 'Transporteur local', 'Livrée'];
      var subs = [d ? fd(d) : '', e ? fd(e) : '', '', '', r.to && !r.off ? 'vers le ' + fd(r.to) : ''];
      var h = '<div class="nt-suivi-res__head"><h2 class="nt-suivi-res__status">' + esc(r.title) + '</h2>';
      h += '<p class="nt-suivi-res__sub">' + (m.name ? '<b>Commande ' + esc(m.name) + '</b> · ' : '') + esc(r.sub) + '</p></div>';
      if (m.ships.length > 1) {
        h += '<div class="nt-suivi-parcels" role="group" aria-label="Colis de la commande">';
        m.ships.forEach(function (s, i) { h += '<button type="button" aria-pressed="' + (i === idx) + '" class="' + (i === idx ? 'is-on' : '') + '" data-parcel="' + i + '">Colis ' + (i + 1) + '</button>'; });
        h += '</div>';
      }
      h += '<div class="nt-suivi-trail' + (r.idle ? ' nt-suivi-trail--idle' : '') + '" style="--f:0"><div class="nt-suivi-trail__line"><i></i></div><div class="nt-suivi-trail__runner' + (HASRUN ? '' : ' nt-suivi-trail__runner--dot') + '" aria-hidden="true">' + RUNNER + '</div><ol class="nt-suivi-trail__stops">';
      labels.forEach(function (l, i) {
        var cls = r.idle ? '' : (i < r.step ? 'is-done' : (i === r.step ? 'is-now' : ''));
        h += '<li class="' + cls + '"' + (cls === 'is-now' ? ' aria-current="step"' : '') + '><b>' + l + '</b>' + (subs[i] ? '<small>' + esc(subs[i]) + '</small>' : '') + '</li>';
      });
      h += '</ol></div>';
      if (!r.idle) h += '<p class="nt-suivi-trail__note">Position estimée d’après les dates réelles de votre commande.</p>';

      var facts = '';
      if (d) facts += '<div class="nt-suivi-fact"><span>Commande passée</span><strong>' + fd(d, true) + '</strong></div>';
      if (e) facts += '<div class="nt-suivi-fact"><span>Colis expédié</span><strong>' + fd(e, true) + '</strong></div>';
      if (e && !r.off) facts += '<div class="nt-suivi-fact"><span>En route depuis</span><strong>' + plural(r.since, 'jour') + '</strong></div>';
      if (r.from && !r.off) facts += '<div class="nt-suivi-fact nt-suivi-fact--key"><span>Livraison estimée</span><strong>' + fd(r.from) + ' → ' + fd(r.to) + '</strong></div>';
      if (facts) h += '<div class="nt-suivi-facts">' + facts + '</div>';

      // Point d'extension : les étapes réelles du transporteur ne peuvent venir que d'une application de suivi
      // installée par le propriétaire (cfg.events). Sans elle, la page s'en tient aux dates réelles de la commande.
      h += '<div class="nt-suivi-help"><p>' + (r.late ? '<b>Besoin d’aide ?</b> Donnez-nous votre numéro de commande, on s’en occupe.' : 'Une question sur cette commande ? Écrivez-nous, on s’en occupe.') + '</p>' + (CONTACT ? '<a href="' + esc(CONTACT) + '">Nous écrire</a>' : '') + '</div>';

      result.innerHTML = h;
      result.hidden = false;
      result._m = m;
      var trail = result.querySelector('.nt-suivi-trail');
      var go = function () { if (trail) trail.style.setProperty('--f', String(r.idle ? 0 : r.f)); };
      if (window.requestAnimationFrame) requestAnimationFrame(function () { requestAnimationFrame(go); }); else go();
    }

    function show(m, idx, scroll) {
      render(m, idx);
      if (scroll !== false && result.scrollIntoView) {
        var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        try { result.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' }); } catch (e) { result.scrollIntoView(); }
      }
    }

    result.addEventListener('click', function (ev) {
      var t = ev.target;
      if (t.getAttribute && t.getAttribute('data-parcel') !== null && result._m) render(result._m, +t.getAttribute('data-parcel'));
    });

    /* commandes du client connecté */
    if (orders.length && box && list) {
      var h = '';
      orders.forEach(function (o, i) {
        var m = modelFromOrder(o), shipped = m.ships.length > 0;
        var st = o.cancelled ? ['Annulée', 'off'] : (shipped ? ['Expédiée', 'go'] : ['En préparation', 'prep']);
        var d = pd(o.date);
        h += '<button type="button" class="nt-suivi-oc" data-order="' + i + '"><span class="nt-suivi-oc__top"><span class="nt-suivi-oc__name">' + esc(o.name) + '</span><span class="nt-suivi-oc__date">' + (d ? fd(d, true) : '') + '</span></span><span class="nt-suivi-oc__imgs">';
        (o.items || []).forEach(function (it) { h += it.img ? '<img src="' + esc(it.img) + '" alt="' + esc(it.t) + '" width="46" height="46" loading="lazy">' : '<span></span>'; });
        if (o.count > (o.items || []).length) h += '<span>+' + (o.count - o.items.length) + '</span>';
        h += '</span><span class="nt-suivi-oc__st nt-suivi-oc__st--' + st[1] + '">' + st[0] + (shipped && m.ships.length > 1 ? ' · ' + m.ships.length + ' colis' : '') + '</span></button>';
      });
      list.innerHTML = h;
      box.hidden = false;
      list.addEventListener('click', function (ev) {
        var b = ev.target.closest ? ev.target.closest('[data-order]') : null; if (!b) return;
        [].forEach.call(list.querySelectorAll('.nt-suivi-oc'), function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on'); say('');
        show(modelFromOrder(orders[+b.getAttribute('data-order')]), 0);
      });
    }

    function findOrder(q) {
      for (var i = 0; i < orders.length; i++) {
        var o = orders[i], n = clean(o.name);
        if (n === q || (digits(n) && digits(n) === digits(q) && isOrderNo(q))) return modelFromOrder(o);
        var m = modelFromOrder(o);
        for (var j = 0; j < m.ships.length; j++) if (m.ships[j].n && m.ships[j].n === q) { m._idx = j; return m; }
      }
      return null;
    }

    function lookup(raw, scroll) {
      var q = clean(raw);
      if (!q) { say('Entrez votre numéro de commande.'); return; }
      var m = findOrder(q);
      if (m) { say(''); show(m, m._idx || 0, scroll); return; }
      say('Cette commande n’est pas dans votre compte. Vérifiez le numéro dans votre e-mail de confirmation, ou écrivez-nous.');
    }

    if (form && input) form.addEventListener('submit', function (ev) { ev.preventDefault(); lookup(input.value); });

    /* arrivée depuis l'e-mail d'expédition : ?n=NUM[,NUM]&c=<commande>&d=AAAA-MM-JJ&e=AAAA-MM-JJ */
    var qs = {};
    location.search.replace(/^\?/, '').split('&').forEach(function (p) { var kv = p.split('='); if (kv[0]) { try { qs[kv[0]] = decodeURIComponent((kv[1] || '').replace(/\+/g, ' ')); } catch (e) {} } });
    if (qs.n) {
      var nums = qs.n.split(',').map(clean).filter(isTrack).slice(0, 6);
      if (nums.length) {
        var known = findOrder(nums[0]);
        if (known) show(known, known._idx || 0, false);
        else show({ name: /^#?[A-Za-z]{0,4}\d{3,9}$/.test(qs.c || '') ? qs.c : '', date: pd(qs.d) ? qs.d : '', ships: nums.map(function (n) { return { d: pd(qs.e) ? qs.e : '', n: n }; }), cancelled: false }, 0, false);
      }
    } else if (orders.length === 1) {
      show(modelFromOrder(orders[0]), 0, false);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (window.InstantClick && window.InstantClick.on) { try { window.InstantClick.on('change', init); } catch (e) {} }
})();
